var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection33Img(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 19.5,
    stroke: "#FFEACC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6667 12V32L34.9985 27L28.3333 32V12M15 50.3333C15 49.0073 15.5268 47.7355 16.4645 46.7978C17.4021 45.8601 18.6739 45.3333 20 45.3333H48.3333V12H20C18.6739 12 17.4021 12.5268 16.4645 13.4645C15.5268 14.4021 15 15.6739 15 17V50.3333ZM15 50.3333V52H45",
    stroke: "#FD6363",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection33Img);
export default __webpack_public_path__ + "static/media/section-3-3-img.5c03bbe47d32da90d9f9087d42f3a105.svg";
export { ForwardRef as ReactComponent };